import matterService from '~/src/services/matter';
import { useCallback } from 'react';
import { useStore } from './useMst';
import { useCurrentOrgFprint } from '../entities/user';

export const useFetchMatterDetail = () => {
  const {
    matter: matterStore,
    projects: projectsStore,
    contacts: contactsStore,
  } = useStore();
  const orgFprint = useCurrentOrgFprint();
  return useCallback(
    async (matterId) => {
      const {
        matter: nextMatter,
        attachedProjects,
        attachedContacts,
      } = await matterService.fetchMatter(orgFprint, matterId);

      attachedProjects.map(projectsStore.addProject);
      attachedContacts.map(contactsStore.addContact);

      nextMatter.documentCount = attachedProjects
        .map((project) => project.documents.length)
        .reduce((acc, val) => acc + val, 0);

      matterStore.setMatter(nextMatter);
      return matterStore.getMatter(matterId);
    },
    [matterStore, projectsStore, contactsStore, orgFprint],
  );
};
